import { render, staticRenderFns } from "./FullMember.vue?vue&type=template&id=62967fac&"
import script from "./FullMember.vue?vue&type=script&lang=js&"
export * from "./FullMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports